import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer data-testid={FOOTER.root} className="bg-lak-bg text-lak-text relative overflow-hidden border-t border-black/10">
      {/* Editorial manifesto / CTA band */}
      <section className="lak-section py-28 sm:py-40">
        <div className="max-w-[1480px] mx-auto px-6 sm:px-10 lg:px-14">
          <Reveal>
            <span className="eyebrow">A short note from the atelier</span>
          </Reveal>

          <div className="mt-10 grid grid-cols-12 gap-10 items-end">
            <div className="col-span-12 lg:col-span-8">
              <Reveal delay={0.05}>
                <p className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05]">
                  Quietly designed. <em className="italic text-lak-sage">Carefully built.</em>
                </p>
              </Reveal>
            </div>
            <div className="col-span-12 lg:col-span-4">
              <Reveal delay={0.15}>
                <Link
                  to="/contact"
                  data-testid={FOOTER.enquireCta}
                  className="group inline-flex items-center justify-between gap-4 sm:gap-6 w-full lg:w-auto pl-4 sm:pl-6 pr-2 sm:pr-3 py-4 border border-black/20 hover:border-lak-text transition-colors max-w-full"
                >
                  <span className="eyebrow">Begin a project</span>
                  <span className="flex items-center justify-center w-12 h-12 bg-lak-text text-lak-bg group-hover:bg-lak-sage transition-colors">
                    <ArrowUpRight size={18} strokeWidth={1.25} />
                  </span>
                </Link>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      {/* Oversized brand wordmark with quiet detail rows */}
      <section className="lak-section bg-lak-secondary pt-20 sm:pt-28 pb-10 relative">
        <div className="max-w-[1480px] mx-auto px-6 sm:px-10 lg:px-14">
          <div className="grid grid-cols-12 gap-10">
            {/* Three editorial info columns */}
            <div className="col-span-6 sm:col-span-4 lg:col-span-3">
              <span className="eyebrow">The atelier</span>
              <ul className="mt-5 space-y-3 text-sm">
                <li><Link to="/" className="link-underline">Home</Link></li>
                <li><Link to="/work" className="link-underline">Work</Link></li>
                <li><Link to="/services" className="link-underline">Services</Link></li>
                <li><Link to="/pricing" className="link-underline">Pricing</Link></li>
                <li><Link to="/process" className="link-underline">Process</Link></li>
                <li><Link to="/about" className="link-underline">About</Link></li>
              </ul>
            </div>
            <div className="col-span-6 sm:col-span-4 lg:col-span-3">
              <span className="eyebrow">Quietly in touch</span>
              <ul className="mt-5 space-y-3 text-sm">
                <li>
                  <a href="mailto:info@lakatelier.com" className="link-underline font-serif italic text-lg">info@lakatelier.com</a>
                </li>
                <li className="text-lak-soft">London, United Kingdom</li>
                <li><Link to="/contact" className="link-underline">Begin a project</Link></li>
              </ul>
            </div>
            <div className="hidden lg:block lg:col-span-3">
              <span className="eyebrow">Hours</span>
              <ul className="mt-5 space-y-3 text-sm text-lak-soft">
                <li>Mon &mdash; Fri</li>
                <li>09:30 to 18:00 GMT</li>
                <li>Replies within one working day</li>
              </ul>
            </div>
            <div className="col-span-12 sm:col-span-4 lg:col-span-3">
              <span className="eyebrow">Manifesto</span>
              <p className="mt-5 font-serif italic text-xl leading-snug text-lak-soft max-w-xs">
                Beautiful web design should not be reserved for the businesses that can already afford it.
              </p>
            </div>
          </div>

          {/* Bottom rule + legal */}
          <div className="rule mt-20 sm:mt-28" />
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between pt-6 gap-4 text-xs text-lak-soft">
            <p>&copy; {new Date().getFullYear()} LAK Atelier. Thoughtfully designed. Strategically built.</p>
            <ul className="flex flex-wrap gap-x-6 gap-y-1">
              <li><Link to="/privacy" className="link-underline">Privacy</Link></li>
              <li><Link to="/terms" className="link-underline">Terms</Link></li>
              <li><span className="eyebrow">Boutique Web Design · United Kingdom</span></li>
            </ul>
          </div>
        </div>
      </section>
    </footer>
  );
}
